export const Config = {
  minYear: 1998
}

export const NemRegions = [
  { label: 'NSW', value: 'NSW1' },
  { label: 'QLD', value: 'QLD1' },
  { label: 'VIC', value: 'VIC1' },
  { label: 'SA', value: 'SA1' },
  { label: 'TAS', value: 'TAS1' }
];

export const ElectricityRegions = [...NemRegions, { label: 'WA', value: 'WA' }];

export const DerSourceList = [
  { label: 'All sources', value: 'ALL' },
  { label: 'Solar', value: 'SOLAR' },
  { label: 'Battery', value: 'BATTERY' },
  { label: 'Other sources', value: 'OTHER' }
];

export const DerInstallationTypeList = [
  { label: 'All installations', value: 'ALL' },
  { label: 'Business', value: 'BUSINESS' },
  { label: 'Residential', value: 'RESIDENTIAL' },
  { label: 'Other installations', value: 'OTHER' }
];

export const CsvDownloadMonths = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' }
];

export function CsvDownloadYears() : number[] {
  const years: number[] = [];
  const currentYear = new Date().getFullYear();

  // Always return the market start year
  if (currentYear < Config.minYear) return [this.minYear];

  for (let x = Config.minYear; x <= currentYear; x++) {
    years.unshift(x);
  }

  return years;
}

export const FuelTypeMap = {
  'default': { icon: 'electricity', colour: '#3379bf', border: '#3379bf', renewable: false },
  'Black coal': { icon: 'aemo_coal', colour: '#333536', border: '#333536', renewable: false },
  'Hydro': { icon: 'aemo_hydro', colour: '#ADE0EE', border: '#ADE0EE', renewable: true },
  'Kerosene - non aviation': { icon: 'aemo_fuel_oil', colour: '#FE5F55', border: '#FE5F55', renewable: false },
  'Natural Gas (Pipeline)': { icon: 'aemo_gas', colour: '#34B9B3', border: '#34B9B3', renewable: false },
  'Solar': { icon: 'aemo_solar_farm', colour: '#FFD565', border: '#FFD565', renewable: true },
  'Wind': { icon: 'wind-generation', colour: '#A1D978', border: '#A1D978', renewable: true },
  'Brown coal': { icon: 'aemo_coal', colour: '#97785C', border: '#97785C', renewable: false },
  'Battery Storage': { icon: 'aemo_battery_storage', colour: '#B056BC', border: '#B056BC' },
  'Diesel oil': { icon: 'aemo_fuel_oil', colour: '#FE5F55', border: '#FE5F55', renewable: false },
  'Coal seam methane': { icon: 'aemo_gas', colour: '#34B9B3', border: '#34B9B3', renewable: false },
  'Biomass': { icon: 'aemo_biomass', colour: '#A82140', border: '#A82140', renewable: true },
  'Battery': { icon: 'aemo_battery_storage', colour: '#B056BC', border: '#B056BC', renewable: true },
  'Gas': { icon: 'aemo_gas', colour: '#34B9B3', border: '#34B9B3', renewable: false },
  'Liquid Fuel': { icon: 'aemo_fuel_oil', colour: '#FE5F55', border: '#FE5F55', renewable: false },
  'Rooftop PV': { icon: 'aemo_solar_rooftop', colour: '#FFED90', border: '#FFED90', renewable: true },
  'Distributed PV': { icon: 'aemo_solar_rooftop', colour: '#FFED90', border: '#FFED90', renewable: true },
  'Utility-scale Solar': { icon: 'aemo_solar_farm', colour: '#FFD565', border: '#FFD565', renewable: true }
};



// WEBPACK FOOTER //
// src/views/electricity/config.ts